export default __webpack_public_path__ + "static/media/W_Wirapaga.3ea1f03a.mp3";